/* Collection page (Design v2, 24 Sep 2026) — sections/rr-collection.liquid.
   Vanilla, deferred, delegated at document level (survives theme-editor re-renders). Two jobs:
   1. Dove/Slate swatches: swap the card's photo and every [data-rrc-link] href.
   2. Inline "Add" on single-option accessories: POST /cart/add.js id=…&quantity=1 (same shape as the homepage buy box)
      -> theme.addToCartOk(item) -> the theme's inline cart refresh + right drawer; fetch -> /cart fallback without theme.js.
   FAQ accordion is handled by rr-home.js (.rrh-acc__btn). */
(function () {
  "use strict";
  if (window.__rrCollectionJS) return;
  window.__rrCollectionJS = true;

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function pick(sw) {
    var root = closest(sw, "[data-rrc-twin-root]");
    if (!root) return;
    var face = sw.getAttribute("data-rrc-sw");
    var href = sw.getAttribute("data-href");
    each(root.querySelectorAll("[data-rrc-sw]"), function (b) { b.setAttribute("aria-pressed", String(b === sw)); });
    each(root.querySelectorAll("[data-rrc-face]"), function (img) {
      if (img.getAttribute("data-rrc-face") === face) img.removeAttribute("hidden"); else img.setAttribute("hidden", "");
    });
    if (href) each(root.querySelectorAll("[data-rrc-link]"), function (a) { a.setAttribute("href", href); });
  }

  function add(btn) {
    if (btn.disabled) return;
    var id = btn.getAttribute("data-rrc-add");
    var label = btn.querySelector("[data-rrc-add-label]");
    var card = closest(btn, ".rrc-card");
    var err = card && card.querySelector("[data-rrc-error]");
    var idle = btn.getAttribute("data-idle") || (label ? label.textContent : "");
    btn.setAttribute("data-idle", idle);
    btn.disabled = true;
    if (label) label.textContent = btn.getAttribute("data-busy") || "Adding…";
    if (err) { err.setAttribute("hidden", ""); err.textContent = ""; }
    function ok() {
      btn.disabled = false;
      if (label) label.textContent = btn.getAttribute("data-done") || idle;
      setTimeout(function () { if (label) label.textContent = idle; }, 2400);
    }
    function fail(msg) {
      btn.disabled = false;
      if (label) label.textContent = idle;
      if (err) { err.textContent = msg || "Sorry, something went wrong. Please try again."; err.removeAttribute("hidden"); }
    }
    var $ = window.jQuery;
    if ($ && window.theme && typeof window.theme.addToCartOk === "function") {
      $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: { id: id, quantity: 1 } })
        .done(function (item) { ok(); try { window.theme.addToCartOk(item); } catch (x) { window.location.href = "/cart"; } })
        .fail(function (xhr) { var d = xhr && xhr.responseJSON; fail(d && (d.description || d.message)); });
      return;
    }
    var body = new FormData();
    body.append("id", id);
    body.append("quantity", "1");
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (res.ok) window.location.href = "/cart"; else fail(res.j && (res.j.description || res.j.message)); })
      .catch(function () { fail(); });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!closest(t, ".rrc")) return;
    var b = closest(t, "[data-rrc-sw]");
    if (b) { e.preventDefault(); pick(b); return; }
    b = closest(t, "[data-rrc-add]");
    if (b) { e.preventDefault(); e.stopPropagation(); add(b); }
  }, true);
})();
